import PropTypes from 'prop-types';
import React from 'react';
import Number from '../Number';
import ReadonlyField from './ReadonlyField';
import { resolveValue } from '../../utils/fields';
import { extendedStateType } from '../../types';
import { NO_STATE } from '../../hooks/useExtendedState';

ReadonlyNumberField.propTypes = {
    label: PropTypes.node,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    postfix: PropTypes.node,
    className: PropTypes.string,
    fractionDigits: PropTypes.number,
    noThousandSeparator: PropTypes.bool,
    emptyValue: PropTypes.string,
    state: extendedStateType,
};

ReadonlyNumberField.defaultProps = {
    label: null,
    value: undefined,
    postfix: null,
    className: null,
    fractionDigits: null,
    noThousandSeparator: false,
    emptyValue: '',
    state: NO_STATE,
};

function ReadonlyNumberField(props) {
    const {
        label,
        postfix,
        value,
        fractionDigits,
        className,
        noThousandSeparator,
        emptyValue,
        state,
    } = props;
    const resolvedValue = resolveValue(value, state);
    return (
        <ReadonlyField
            label={label}
            postfix={postfix}
            className={className}
            emptyValue={emptyValue}
            value={((resolvedValue === '' || resolvedValue === null) && emptyValue) ? resolvedValue : (
                <Number
                    value={resolvedValue}
                    fractionDigits={fractionDigits}
                    noThousandSeparator={noThousandSeparator}
                />
            )}
        />
    );
}

export default ReadonlyNumberField;
